export const CHANGE_USERNAME = "boilerplate/GSTR8_Home/CHANGE_USERNAME";
export const ON_CALL_UPLOAD = "boilerplate/GSTR8_Landing/ON_CALL_UPLOAD";
export const ON_SUBMIT_TRUE = "boilerplate/GSTR8_UploadPage/ON_SUBMIT_TRUE";
export const SET_PROCESS_COUNT =
  "boilerplate/GSTR8_UploadPage/SET_PROCESS_COUNT";
export const SET_ERR_COUNT = "boilderplate/GSTR8_UploadPage/SET_ERR_COUNT";
export const LOADER_STATUS = "boilderplate/GSTR8_UploadPage/LOADER_STATUS";
export const PROFILE_INFO = "boilerplate/GSTR8_UploadPage/PROFILE_INFO";
export const SUPPLIER_INFO = "boilerplate/GSTR8_UploadPage/SUPPLIER_INFO";
export const SAVE_TOTAL_PAGES =
  "boilderplate/GSTR8_UploadPage/SAVE_TOTAL_PAGES";
export const SET_TABLE_DATA = "GSTR8_/SET_TABLE_DATA";
export const SET_ENTITY_LIST = "GSTR8_/SET_ENTITY_LIST";
export const SET_SELECTED_ENTITY = "GSTR8_/SET_SELECTED_ENTITY";
